import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'renewal.ea.insuredDetailsPage.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    lossOccurredAfterRenewalEffectiveDate: {
        id:
      'renewal.ea.insuredDetailsPage.Loss Occurred After Renewal Effective Date',
        defaultMessage:
      'A loss for this risk occurred on or after the effective date of the renewal?'
    },
    lossOccurredAfterEffectiveDate: {
        id: "renewal.ea.insuredDetailsPage.Has any Liability Loss occurred in the household between the effective date and today's date?",
        defaultMessage: "Has any Liability Loss occurred in the household between the effective date and today's date?"
    },
    lossOccurredAfterRenewalEffectiveDateYes: {
        id:
      'renewal.ea.insuredDetailsPage.Loss Occurred After Renewal Effective Date.Yes',
        defaultMessage: 'Yes'
    },
    lossOccurredAfterRenewalEffectiveDateNo: {
        id:
      'renewal.ea.insuredDetailsPage.Loss Occurred After Renewal Effective Date.No',
        defaultMessage: 'No'
    },
    policyInformation: {
        id: 'renewal.ea.insuredDetailsPage.Policy Information',
        defaultMessage: 'Policy Information'
    },
    lineOfBusiness: {
        id: 'renewal.ea.insuredDetailsPage.Line Of Business',
        defaultMessage: 'Line Of Business'
    },
    periodStartDate: {
        id: 'renewal.ea.insuredDetailsPage.Effective Date',
        defaultMessage: 'Effective Date'
    },
    periodEndDate: {
        id: 'renewal.ea.insuredDetailsPage.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'renewal.ea.insuredDetailsPage.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    riskState: {
        id: 'renewal.ea.insuredDetailsPage.Risk State',
        defaultMessage: 'Risk State'
    },
    policyType: {
        id: 'renewal.ea.insuredDetailsPage.Policy Type',
        defaultMessage: 'Policy Type'
    },
    insuredInfo: {
        id: 'renewal.ea.insuredDetailsPage.Insured Information',
        defaultMessage: 'Insured Information'
    },
    insuredFirstName: {
        id: 'renewal.ea.insuredDetailsPage.insuredInformation.FirstName',
        defaultMessage: 'First Name'
    },
    insuredMiddleName: {
        id: 'renewal.ea.insuredDetailsPage.insuredInformation.MiddleName',
        defaultMessage: 'M.I.'
    },
    insuredLastName: {
        id: 'renewal.ea.insuredDetailsPage.insuredInformation.Last Name',
        defaultMessage: 'Last Name'
    },
    insuredSuffix: {
        id: 'renewal.ea.insuredDetailsPage.insuredInformation.Suffix',
        defaultMessage: 'Suffix'
    },
    insuredAddress: {
        id: 'renewal.ea.insuredDetailsPage.Insured Residence Information',
        defaultMessage: 'Insured Residence Address'
    },
    insuredAddressAddressLine1: {
        id: 'renewal.ea.insuredDetailsPage.insuredAddress.Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    insuredAddressAddressLine2: {
        id: 'renewal.ea.insuredDetailsPage.insuredAddress.Address Line 2',
        defaultMessage: 'Address Line 2'
    },
    insuredAddressAddressCity: {
        id: 'renewal.ea.insuredDetailsPage.insuredAddress.City',
        defaultMessage: 'City'
    },
    insuredAddressAddressZipCode: {
        id: 'renewal.ea.insuredDetailsPage.insuredAddress.ZipCode',
        defaultMessage: 'Zip Code'
    },
    insuredAddressAddressState: {
        id: 'renewal.ea.insuredDetailsPage.insuredAddress.State',
        defaultMessage: 'State'
    },
    addNewPni: {
        id: 'renewal.ea.insuredDetailsPage.pni.Add New Pni',
        defaultMessage: 'Add New Pni'
    },
    agencyInformation: {
        id: 'renewal.ea.insuredDetailsPage.Agency Information',
        defaultMessage: 'Agency Information'
    },
    locationCode: {
        id: 'renewal.ea.insuredDetailsPage.Location Code',
        defaultMessage: 'Location Code'
    },
    chooseProducerCode: {
        id: 'renewal.ea.insuredDetailsPage.Choose Producer Code',
        defaultMessage: 'Please Select'
    },
    agencyName: {
        id: 'renewal.ea.insuredDetailsPage.AgencyName',
        defaultMessage: 'Agency Name'
    },
    sourceOfEntry: {
        id: 'renewal.ea.insuredDetailsPage.Source Type',
        defaultMessage: 'Source of Entry'
    },
    standardizingAddressMessage: {
        id: 'renewal.ea.insuredDetailsPage.Standardizing address...',
        defaultMessage: 'Standardizing address...'
    },
    rentOrOwn: {
        id: 'renewal.ea.insuredDetailsPage.Rent or Own?',
        defaultMessage: 'Rent or Own?'
    },
    own: {
        id: 'renewal.ea.insuredDetailsPage.Rent Or Own.Own',
        defaultMessage: 'Own'
    },
    rent: {
        id: 'renewal.ea.insuredDetailsPage.Rent Or Own.Rent',
        defaultMessage: 'Rent'
    },
    renewalDate: {
        id: 'renewal.ea.insuredDetailsPage.Policy Renewal Effective Date',
        defaultMessage: 'Policy Renewal Effective Date'
    },
});
